import { Stack } from '@mui/material';
import CheckoutWizard from '../../../components/displays/storeFront/checkout/CheckoutWizard';
import useCheckoutStore from '../../../stores/public/useCheckoutStore';

export default function StorefrontCheckout() {
  const { order, reservations } = useCheckoutStore();

  return (
    <Stack>
      <Stack px={2}>
        <CheckoutWizard order={order} reservations={reservations} />
      </Stack>
    </Stack>
  );
}